import { render, staticRenderFns } from "./CadastroComunicado.vue?vue&type=template&id=c59becfa&scoped=true&"
import script from "./CadastroComunicado.vue?vue&type=script&lang=js&"
export * from "./CadastroComunicado.vue?vue&type=script&lang=js&"
import style0 from "./CadastroComunicado.vue?vue&type=style&index=0&id=c59becfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59becfa",
  null
  
)

export default component.exports